module.exports = __webpack_public_path__ + "assets_app/img/audio_pause.7a97eda1.svg";